export enum MethodType {
  milling = "밀링",
  shelf = "선반",
}